import api from '../apiService.js';
import { initializeSelect2 } from '../initialize-select2.js';
import { createDebouncedMemoRequest, populateFields, clearFields, propSpinner, disableSaveButton } from '../utils';
import { searchCarAnia } from './search-car-ania';

const fieldMap = (data) => ({
    //insured
    insured_provincia: data.insured_provincia || null,
    insured_fiscal_code: data.insured_fiscal_code || null,
    insured: data.insured || null,
    insured_name: data.insured_name || null,
    insured_last_name: data.insured_last_name || null,
    insured_birthdate: data.insured_birthdate || null,
    insured_cap: data.insured_cap || null,
    insured_city: data.insured_city?.toUpperCase() || null,
    insured_city_istat: data.insured_city_istat || null,
    insured_address: data.insured_address || null,
    insured_telephone: data.insured_telephone || null,
    insured_email: data.insured_email || null,
    insured_area: data.insured_area || null,
    //owner
    owner_provincia: data.owner_provincia || null,
    owner: data.owner || null,
    owner_name: data.owner_name || null,
    owner_last_name: data.owner_last_name || null,
    owner_cap: data.owner_cap || null,
    owner_address: data.owner_address || null,
    owner_email: data.owner_email || null,
    owner_telephone: data.owner_telephone || null,
    owner_area: data.owner_area || null,
    owner_comune: data.owner_comune?.toUpperCase() || null,
    owner_comune_istat: data.owner_comune_istat || null,
    owner_birthdate: data.owner_birthdate || null,
    owner_fiscal_code: data.owner_fiscal_code || null,
    //policy
    plate: data.plate || null,
    plate_country: data.plate_country || null,
    plate_type: data.plate_type || null,
    veichle_type: data.veichle_type || null,
    // policy_number: data.policy_number || null,
    policy_decorrenza: data.policy_decorrenza || null,
    policy_termine: data.policy_termine || null,
    cat_garanzia_implicata: data.cat_garanzia_implicata || null,
    cat_garanzia_implicata_options: data.cat_garanzia_implicata_options || {},
    cod_garanzia_implicata: data.cod_garanzia_implicata || null,
    cod_garanzia_implicata_options: data.cod_garanzia_implicata_options || {},
    policy_show_page_link: data.policy_show_page_link || '',
    policy_agency_id: data.policy_agency_id,
    policy_intermediario_id: data.policy_intermediario_id,
    policy_produttore_id: data.policy_produttore_id,
    policy_covered: data.policy_covered || false,
});

const fieldNames = Object.keys(fieldMap({}));

const debounceSearch = createDebouncedMemoRequest(api.getData, 300);

window.fetchPlateDataForBothParties = async function() {
    await fetchInsuredData("plate");
    await fetchOtherPartyByPlate("other_plate");
};

window.fetchInsuredData = async function fetchInsuredData(fieldName) {
    const fieldValue = $('[name="' + fieldName + '"]').val();
    const eventDate = $('[name=event_date]').val();
    const group = $('[name=group]').val();
    const vehicleType = $('[name=veichle_type]').val() || null;
    if (!fieldValue) {
        clearFields(fieldNames);
        return;
    }

    propSpinner(fieldNames, true);
    disableSaveButton(true);

    const cacheKey = `${fieldName}-${fieldValue}-${eventDate}`;

    return debounceSearch(cacheKey, `/api/app/backpack/fetch-insured-data`, {
        params: {
            [fieldName]: fieldValue.toUpperCase(),
            event_date: eventDate,
            group: group,
            vehicle_type: vehicleType
        },
    }).then((data) => {
        if (data) {
            populateFields(fieldMap(data));
            updateSelectOptions('cat_garanzia_implicata', data.cat_garanzia_implicata_options);
            updateSelectOptions('cod_garanzia_implicata', data.cod_garanzia_implicata_options);

            updatePolicyLink(data.policy_show_page_link);
        }
    })
    .catch(() => {
        updateSelectOptions('cat_garanzia_implicata', { 'cvt': 'CVT', 'rca': 'RCA' });
        updateSelectOptions('cod_garanzia_implicata', {});
        updatePolicyLink(null);
    })
    .finally(() => {
        propSpinner(fieldNames, false);
        disableSaveButton(false);
    });
};

function updateSelectOptions(fieldName, options) {
    const selectField = $('[name="' + fieldName + '"]');
    if (selectField.length && options && Object.keys(options).length > 0) {
        if (selectField.is('input[type="text"]')) {
            const newSelectField = $('<select>').attr({
                name: fieldName,
                class: selectField.attr('class')
            });
            selectField.replaceWith(newSelectField);
            initializeSelect2(newSelectField);
        }

        const updatedSelectField = $('[name="' + fieldName + '"]');
        updatedSelectField.empty();
        let firstValue = null;
        $.each(options, function (value, label) {
            if (firstValue === null) firstValue = value;
            updatedSelectField.append(new Option(label, value));
        });
        initializeSelect2(updatedSelectField, firstValue);
    } else if (fieldName === 'cod_garanzia_implicata' && (!options || Object.keys(options).length === 0)) {
        if (!selectField.is('input[type="text"]')) {
            const textField = $('<input>').attr({
                type: 'text',
                name: fieldName,
                class: selectField.attr('class')
            });
            selectField.replaceWith(textField);
        }
    }
}

function updatePolicyLink(link) {
    const policyLink = $('#policy_link');
    if (policyLink.length) {
        const containerDiv = policyLink.closest('div');
        if (link) {
            containerDiv.removeClass('d-none');
            policyLink.attr('href', link);
        } else {
            containerDiv.addClass('d-none');
            policyLink.removeAttr('href');
        }
    }
}

window.fetchOtherPartyByPlate = async (fieldName) => {
    const fieldValue = $('[name="' + fieldName + '"]').val();
    const eventDate = $('[name=event_date]').val();
    const group = $('[name=group]').val();
    const otherVehicleType = $('[name=other_veichle_type]').val() || null;
    if (!fieldValue) {
        return;
    }

    const otherCompanyFields = ['other_company', 'other_insured_fiscal_code', 'other_company_policy',
        'other_insured_name', 'other_insured_last_name', 'other_insured'];
    propSpinner(otherCompanyFields, true);
    disableSaveButton(true);

    const cacheKey = `${fieldName}-${fieldValue}-${eventDate}-ania`;

    return debounceSearch(cacheKey, `/api/app/backpack/fetch-insured-data`, {
        params: {
            plate: fieldValue.toUpperCase(),
            event_date: eventDate,
            group: group,
            should_return_exception: false,
            vehicle_type: otherVehicleType,
        },
    }).then((data) => {
        if (data) {
            $('[name=other_insured]').val(data.insured);
            $('[name=other_insured_name]').val(data.insured_name);
            $('[name=other_insured_last_name]').val(data.insured_last_name);
            $('[name=other_insured_fiscal_code]').val(data.insured_fiscal_code);
            $('[name=other_company_policy]').val(data.policy_number);
            $('[name=other_plate_type]').val(data.plate_type);
            $('[name=other_veichle_type]').val(data.veichle_type);
        } else {
            searchCarAnia(fieldName)
        }
    })
    .finally(() => {
        propSpinner(otherCompanyFields, false);
        disableSaveButton(false);
    });
};
